import {
  FreeBetAmounts,
  TAdvancedFreebet,
  TGetFreeBetAmountEvent
} from 'interfaces/bet-data';
import { getV3Freebet } from 'services/bet-slip';

type TFetchFreeBetAmounts = (params: {
  events: TGetFreeBetAmountEvent[];
  isLive: boolean;
  type?: number;
  callback?: (data: TAdvancedFreebet[]) => void;
}) => Promise<FreeBetAmounts>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mockedFreeBetsResponse = {
  result: 0,
  result_text: null,
  details: [
    {
      id: 712612332,
      amount: 5,
      expiration_date: 1714641075,
      bet_types: [2, 1]
    },
    {
      id: 712782254,
      amount: 4,
      expiration_date: 1714652711,
      bet_types: [2, 1]
    },
    {
      id: 712782453,
      amount: 3,
      expiration_date: 1714652719,
      bet_types: [2, 1]
    },
    {
      id: 712782681,
      amount: 5,
      expiration_date: 1714652728,
      bet_types: [2, 1]
    },
    {
      id: 718389058,
      amount_percent: 8,
      bet_type: 0,
      expiration_date: 1714466644,
      boost_max_bet_amounts: [
        {
          Currency: 'EUR',
          MaxBetAmount: 75
        },
        {
          Currency: 'USD',
          MaxBetAmount: 75
        },
        {
          Currency: 'GHS',
          MaxBetAmount: 600
        },
        {
          Currency: 'IDR',
          MaxBetAmount: 1000
        },
        {
          Currency: 'KZT',
          MaxBetAmount: 40000
        },
        {
          Currency: 'KES',
          MaxBetAmount: 9000
        },
        {
          Currency: 'MYR',
          MaxBetAmount: 350
        },
        {
          Currency: 'RUB',
          MaxBetAmount: 5500
        },
        {
          Currency: 'THB',
          MaxBetAmount: 2700
        },
        {
          Currency: 'VND',
          MaxBetAmount: 1800
        },
        {
          Currency: 'CAD',
          MaxBetAmount: 100
        },
        {
          Currency: 'AMD',
          MaxBetAmount: 35000
        },
        {
          Currency: 'KRW',
          MaxBetAmount: 100000
        },
        {
          Currency: 'BDT',
          MaxBetAmount: 8500
        },
        {
          Currency: 'FTN',
          MaxBetAmount: 100
        },
        {
          Currency: 'UAH',
          MaxBetAmount: 3000
        }
      ]
    },
    {
      id: 718389064,
      amount_percent: 10,
      bet_type: 0,
      expiration_date: 1714466645,
      boost_max_bet_amounts: [
        {
          Currency: 'EUR',
          MaxBetAmount: 50
        },
        {
          Currency: 'USD',
          MaxBetAmount: 50
        },
        {
          Currency: 'GHS',
          MaxBetAmount: 400
        },
        {
          Currency: 'IDR',
          MaxBetAmount: 750
        },
        {
          Currency: 'KZT',
          MaxBetAmount: 25000
        },
        {
          Currency: 'KES',
          MaxBetAmount: 6000
        },
        {
          Currency: 'MYR',
          MaxBetAmount: 200
        },
        {
          Currency: 'RUB',
          MaxBetAmount: 3500
        },
        {
          Currency: 'THB',
          MaxBetAmount: 1800
        },
        {
          Currency: 'VND',
          MaxBetAmount: 1200
        },
        {
          Currency: 'CAD',
          MaxBetAmount: 75
        },
        {
          Currency: 'AMD',
          MaxBetAmount: 25000
        },
        {
          Currency: 'KRW',
          MaxBetAmount: 67000
        },
        {
          Currency: 'BDT',
          MaxBetAmount: 5600
        },
        {
          Currency: 'FTN',
          MaxBetAmount: 75
        },
        {
          Currency: 'UAH',
          MaxBetAmount: 2000
        }
      ]
    },
    {
      id: 718389068,
      amount_percent: 5,
      bet_type: 0,
      expiration_date: 1714466645,
      boost_max_bet_amounts: [
        {
          Currency: 'EUR',
          MaxBetAmount: 100
        },
        {
          Currency: 'USD',
          MaxBetAmount: 100
        },
        {
          Currency: 'GHS',
          MaxBetAmount: 75
        },
        {
          Currency: 'IDR',
          MaxBetAmount: 1500
        },
        {
          Currency: 'KZT',
          MaxBetAmount: 50000
        },
        {
          Currency: 'KES',
          MaxBetAmount: 12000
        },
        {
          Currency: 'MYR',
          MaxBetAmount: 450
        },
        {
          Currency: 'RUB',
          MaxBetAmount: 7000
        },
        {
          Currency: 'THB',
          MaxBetAmount: 3500
        },
        {
          Currency: 'VND',
          MaxBetAmount: 2500
        },
        {
          Currency: 'CAD',
          MaxBetAmount: 150
        },
        {
          Currency: 'AMD',
          MaxBetAmount: 50000
        },
        {
          Currency: 'KRW',
          MaxBetAmount: 135000
        },
        {
          Currency: 'BDT',
          MaxBetAmount: 11300
        },
        {
          Currency: 'UZS',
          MaxBetAmount: 1250000
        },
        {
          Currency: 'FTN',
          MaxBetAmount: 120
        },
        {
          Currency: 'UAH',
          MaxBetAmount: 4000
        }
      ]
    }
  ]
};

// @Todo need to create some type for freeBet call and do Bet call (based on bet type) betslip-type
export const fetchFreeBetAmounts: TFetchFreeBetAmounts = ({
  events,
  isLive,
  type,
  callback
}) => {
  return new Promise<FreeBetAmounts>(resolve => {
    getV3Freebet(
      {
        Events: events,
        IsLive: isLive,
        Type: type
      },
      data => {
        if (!data.result && data.details.length > 0) {
          const advancedFreeBetsData = data.details.reduce<FreeBetAmounts>(
            (acc, item) =>
              item.amount
                ? [
                    ...acc,
                    {
                      label: item.amount,
                      value: item.id,
                      maxPayouts: item.freebet_max_payouts
                    }
                  ]
                : acc,
            []
          );

          resolve(advancedFreeBetsData);

          callback?.(data.details);
        }

        resolve([]);
      },
      () => {
        resolve([]);
      }
    );
  });
};
